import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import axios from 'axios';
import { ShieldAlert, ArrowLeft } from 'lucide-react';
import MatchReport from './MatchReport';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function ShareReport() {
  const { id } = useParams();
  const [match, setMatch] = useState(null);
  const [status, setStatus] = useState('loading');

  useEffect(() => {
    axios.get(`${API}/matches/${id}`)
      .then(res => { setMatch(res.data); setStatus('ok'); })
      .catch(() => setStatus('error'));
  }, [id]);

  return (
    <div className="min-h-screen bg-black flex justify-center font-sans">
      <div className="w-full max-w-md bg-[#0A0A0A] min-h-screen px-5 py-8">
        {status === 'loading' && (
          <p data-testid="share-loading" className="text-center text-gray-500 mt-20">Loading report…</p>
        )}
        {status === 'error' && (
          <div data-testid="share-error" className="text-center mt-20">
            <ShieldAlert className="w-12 h-12 text-gray-700 mx-auto mb-3" />
            <p className="text-gray-400">Match report not found.</p>
            <Link to="/" className="inline-block mt-6 bg-[#00BFFF] text-black font-bold px-6 py-2 rounded-full text-sm">Open Tournevo</Link>
          </div>
        )}
        {status === 'ok' && (
          <>
            <MatchReport match={match} />
            <Link to="/" data-testid="share-open-app" className="mt-8 w-full bg-[#1C1C1E] border border-gray-800 text-gray-300 font-bold py-3 rounded-xl flex items-center justify-center gap-2">
              <ArrowLeft size={16} /> Open Tournevo
            </Link>
          </>
        )}
      </div>
    </div>
  );
}
